<script lang="ts">
	import FontSpan from '../typography/FontSpan.svelte';

	export let label: string;
	export let icon: string;
	export let value: string;
</script>

<div class="flex items-start gap-2">
	<div class="icon-wrapper">
		<div class="icon icon-{icon}" />
	</div>
	<div class="flex flex-col items-start">
		<FontSpan varient="body-R-06" class="text-gray-50">
			{label}
		</FontSpan>
		<FontSpan varient="body-B-05" class="text-white">
			{value}
		</FontSpan>
	</div>
</div>

<style>
	.icon-wrapper {
		display: flex;
		width: 48px;
		height: 48px;
		padding: 2.571px;
	}
</style>
